/** @format */

import React, { useState, useRef, useEffect } from "react";
import { Input, Form } from "antd";
import { IUsers } from "../../AccountInfoPage.types";

interface IEditableLastNameProps {
	lastName: string;
	editedUsers: IUsers[];
	userId: string;
	setTheEditedUsers: (editedUsersList) => void;
	setIfUsersWereEdited: (value) => void;
	changesWereUndone: boolean;
	setUndoChanges: (value) => void;
}

const EditableLastName: React.FC<IEditableLastNameProps> = ({
	lastName,
	editedUsers,
	userId,
	setTheEditedUsers,
	setIfUsersWereEdited,
	changesWereUndone,
	setUndoChanges,
}) => {
	const [changedLastName, setChangedLastName] = useState<string>(lastName);
	const [isEditingLastName, setIsEditingLastName] = useState<boolean>(false);

	//Close editing mode when clicked outside of input area
	const node: any = useRef();
	useEffect(() => {
		const handleOnClickEditingMode = (e) => {
			if (node.current.contains(e.target)) {
				return;
			}
			if (changedLastName.length > 0) {
				setIsEditingLastName(false);
				setIfUsersWereEdited(true);
				const mappedEditedUsers = editedUsers.map((user) => {
					if (user.userId === userId) {
						user = { ...user, lastName: changedLastName, isEdited: true };
					}
					return user;
				});
				setTheEditedUsers(mappedEditedUsers);
			}
		};

		if (isEditingLastName) {
			document.addEventListener("mousedown", handleOnClickEditingMode);
		} else {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		}

		return () => {
			document.removeEventListener("mousedown", handleOnClickEditingMode);
		};
	}, [
		isEditingLastName,
		changedLastName,
		editedUsers,
		lastName,
		setTheEditedUsers,
		userId,
		setIfUsersWereEdited,
	]);

	const handleOnClickEditing = () => {
		setIsEditingLastName(true);
		setUndoChanges(false);
	};

	const handleOnChangeInput = (e) => {
		setChangedLastName(e.target.value);
	};

	const handleErrorValidation = () => {
		if (changedLastName.length <= 0) {
			return "error";
		} else if (changedLastName.length > 0) {
			return "";
		}
	};

	const handleErrorValidationMessage = () => {
		if (changedLastName.length <= 0) {
			return "Please input a last name.";
		} else if (changedLastName.length > 0) {
			return "";
		}
	};

	useEffect(() => {
		if (changesWereUndone) {
			setChangedLastName(lastName);
		}
	}, [changesWereUndone, lastName]);

	return (
		<div
			className="editable-cell-value-wrapper"
			ref={node}
			onClick={handleOnClickEditing}>
			{isEditingLastName ? (
				<Form.Item
					validateStatus={handleErrorValidation()}
					help={handleErrorValidationMessage()}>
					<Input
						value={changedLastName}
						onChange={handleOnChangeInput}
						style={{ width: "50%" }}
					/>
				</Form.Item>
			) : (
				changedLastName
			)}
		</div>
	);
};

export default EditableLastName;
